module.exports = __webpack_public_path__ + "static/media/04n.72dbd2f4.png";